import _classCallCheck from "/Users/takeuchi.kazuto/projects/framework-agnostic-frontend-usecase-example/apps/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/takeuchi.kazuto/projects/framework-agnostic-frontend-usecase-example/apps/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var WorksheetOperations =
/*#__PURE__*/
function () {
  function WorksheetOperations(update) {
    _classCallCheck(this, WorksheetOperations);

    this.update = update;
  }

  _createClass(WorksheetOperations, [{
    key: "setActiveCellAddress",
    value: function setActiveCellAddress(rowIndex, columnIndex) {
      this.update(function (_ref) {
        var maxCellAddress = _ref.maxCellAddress,
            activeCellAddress = _ref.activeCellAddress;

        if (typeof rowIndex === 'number' && rowIndex >= 0 && rowIndex <= maxCellAddress.rowIndex) {
          activeCellAddress.rowIndex = rowIndex;
        }

        if (typeof columnIndex === 'number' && columnIndex >= 0 && columnIndex <= maxCellAddress.columnIndex) {
          activeCellAddress.columnIndex = columnIndex;
        }
      });
      return this;
    }
  }, {
    key: "moveActiveCellAddress",
    value: function moveActiveCellAddress(rowOffset, columnOffset) {
      this.update(function (_ref2) {
        var maxCellAddress = _ref2.maxCellAddress,
            activeCellAddress = _ref2.activeCellAddress;

        if (typeof rowOffset === 'number' && rowOffset) {
          activeCellAddress.rowIndex = Math.min(Math.max(0, activeCellAddress.rowIndex + rowOffset), maxCellAddress.rowIndex);
        }

        if (typeof columnOffset === 'number' && columnOffset) {
          activeCellAddress.columnIndex = Math.min(Math.max(0, activeCellAddress.columnIndex + columnOffset), maxCellAddress.columnIndex);
        }
      });
      return this;
    }
  }, {
    key: "setActiveCellContent",
    value: function setActiveCellContent(content) {
      this.update(function (_ref3) {
        var _ref3$activeCellAddre = _ref3.activeCellAddress,
            rowIndex = _ref3$activeCellAddre.rowIndex,
            columnIndex = _ref3$activeCellAddre.columnIndex,
            cellContents = _ref3.cellContents;

        if (content) {
          cellContents[rowIndex] = cellContents[rowIndex] || [];
          cellContents[rowIndex][columnIndex] = content;
        } else {
          var row = cellContents[rowIndex];

          if (!row || !row[columnIndex]) {
            return;
          }

          delete cellContents[rowIndex][columnIndex];

          while (row.length && !row[row.length - 1]) {
            row.pop();
          }

          if (row.length) {
            return;
          }

          delete cellContents[rowIndex];

          while (cellContents.length && !cellContents[cellContents.length - 1]) {
            cellContents.pop();
          }
        }
      });
      return this;
    }
  }]);

  return WorksheetOperations;
}();